export const environment = {
  production: true,
  arcGisScriptUrl: 'https://js.arcgis.com/4.7/',
  arcGisCssUrl: 'http://js.arcgis.com/4.7/esri/css/main.css'
};
